<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ">
    <div v-for="(row, index) in pageData"  v-if="pageData.length > 0">
      <van-divider>人员信息{{index+1}}</van-divider>
      <van-cell-group>
        <van-cell title="姓名" :value="row.name"/>
        <van-cell title="编号" :value="row.code"  v-show="row.code"/>
        <van-cell title="身份证" :value="row.num"/>
        <van-cell title="电话" :value="row.phone"/>
        <van-cell title="微信" :value="row.weixin"/>
        <van-cell title="等级" :value="row.grade_name"/>
        <van-cell title="注册日期" :value="row.regist_date|timeFormat"/>
      </van-cell-group>
    </div>
    <div v-if="pageData.length == 0">
      <van-empty description="暂无数据" />
    </div>

  </div>
</template>

<style scoped="">
</style>
<script>
import {
  Cell, CellGroup, Field, RadioGroup, Radio, DatetimePicker, Picker, NoticeBar, Button, Dialog, Uploader, Empty
} from 'vant';

export default {
  name: 'WyhCaipanDetail',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Uploader.name]: Uploader,
    [Empty.name]: Empty,
  },
  data: function () {
    return {
      pageData: [],
      formData: {
        'id': this.$route.query.id,
      },
      showTime: false,
      timeField: '',
      showStation: false,
      stationField: '',
      loadding: false,
    }
  },
  mounted: function () {
    let that = this;
    document.title = "裁判人员信息";
    this.$api.get('/wyhadminapi/caipan/shengApplyDetail', {
      'id': that.$route.query.id
    }, r => {
      this.pageData = r.data.member_list;
      console.log(this.row)
    });

  },

  methods: {
    save: function () {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '您确定信息准确无误吗?提交后不得修改!'
      }).then(() => {
        // on confirm
        that.$api.post('/api/sai/confirmzhixuceaction', this.formData, r => {
          that.$router.push({'name': 'saiConfirm', 'query': {'id': that.row.id}});
        }, r => {
          that.$toast.fail(r.msg);
        });
      }).catch(() => {
        // on cancel
      });


    },
    edit: function () {
      let that = this;
      this.$router.push({
        'name': 'saiConfirmQr1',
        'query': {'id': that.row.id}
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// CaipanDetail.vue?8bde81cc